<template>
    <div    v-if="isSavable"
            class="">
        <div>
            <!-- Mkt Report Settings -->
            <div class="mb-4 lg:mb-2">
                <h4 class="text-center">MKT Report Variations</h4>
                <div    :class="[editInModal ? '' : 'lg:grid-cols-2']"
                        class="grid grid-cols-1 my-8">
                    <p  class="mx-8">
                        <b>MKT Calculation.</b>
                        This report gives you a listing of selected points of monitoring with the
                        calculate MKT for the time frame selected along with the current high and low alarm thresholds.
                    </p>

                    <p  class="mx-8">
                        <b>MKT Detailed.</b>
                        This report gives you a graph of each selected point of monitoring that reflects
                        the daily high and low readings with the calculated MKT for the time frame selected.
                        Each point of Monitoring's details will be listed at the top of the report.
                    </p>
                </div>
            </div>

            <!-- Option to select Report variation -->
            <div    class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
                <span>MKT Report Variation Type</span>
                <select2 id="report_type"
                         v-model:value="$data._settings['reportType']"
                         :allow-clear="false"
                         :close-on-select="true"
                         :multiple="false"
                         :options="reportVariationOptions"
                         :side-by-side="true"
                         @input="updateSettings($event, 'reportType')"
                ></select2>
            </div>
        </div>

        <h4     class="text-center">Interval Settings</h4>
        <!-- Automatic Sending Interval -->
        <div    class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
            <span   v-if="isSavable">Automatic Sending Interval</span>
            <span   v-else>Reporting Interval</span>
            <select2 v-model:value="$data._interval"
                     :close-on-select="true"
                     :options="intervals"
                     @input="updateSettings($event, 'interval')"
            ></select2>
        </div>

        <!-- Weekday to receive weekly reports -->
        <div    v-if="$data._interval === 'weekly'"
                class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
            <span>Day to Receive Report</span>
            <select2 v-model:value="$data._settings['weekday']"
                     :close-on-select="true"
                     :options="weekdayOptions"
                     @input="updateSettings($event, 'weekday')"
            ></select2>
        </div>
    </div>
</template>

<script>
import axios from "axios"

import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";

import Select2 from "@/components/elements/select2";
import {Intervals} from "@/components/GroupReports/Intervals";
import DateTimePicker from "@/components/Reports/VueDatePicker";
import Toggle from "@/components/elements/toggle";

export default {
    name: "MktReportSettings",
    mixins: [SonicuCoreMixin],
    components: {Toggle, DateTimePicker, Select2},
    props: {
        interval: {
            type: String,
            default: Intervals.MONTHLY,
        },
        settings: Object,

        weekdayOptions: {
            type: Object,
            default: Intervals.WEEKDAY_OPTIONS,
        },
        semiMonthOptions: {
            type: Object,
            default: Intervals.SEMI_MONTH_OPTIONS,
        },
        intervals: {
            type: Object,
            default: Intervals.INTERVAL_OPTIONS,
        },
        reportVariationOptions: {
            type: Object,
            default() {
                return []
            },
        },
        isSaving: {
            type: Boolean,
            default: false,
        },
        isSavable: {
            type: Boolean,
            default: false,
        },
        editInModal: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            month: this.maxDate,
            format: _.indexOf(['monthly', 'semi-monthly'], this.interval) > -1 ? 'MMMM YYYY' : 'MMMM DD, YYYY',
            viewMode: _.indexOf(['monthly', 'semi-monthly'], this.interval) > -1  ? 'months' : 'days',

            selectedUsers: this.selectedUsersInput,
            selectedMeters: [],

            _settings: this.settings,

            showReportModal: false,
            reportModalError: false,
            modalMessage: '',
            modalTitle: '',
            isErrorModal: false,

            _interval: this.interval,
            isSaving: false,
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        updateSettings(event, triggeringComponent = 'Unknown') {
            // Update the settings values based on the new local
            this.$emit('update:settings', this.$data._settings)
            this.$forceUpdate()
        },
        ensureSettingKeyExists(key, defaultValue = null) {
            this.$data._settings[key] = Object.keys(this.$data._settings).indexOf(key) !== -1
                    ? this.$data._settings[key]
                    : defaultValue;
        },
        zeropadTime(value, length = 2) {
            if (!(value instanceof String)) {
                value = value.toString()
            }
            while(value.length < length) {
                value = '0' + value
            }
            return value
        },
    },
    computed: {
    },
    watch: {
        _interval(val, old) {
            console.log(`updating _interval from ${old} to ${val}`)
            if (val !== old) {
                this.$emit('update:interval', this.$data._interval)
            }
        },
        interval(val) {
            if (_.indexOf(['weekly'], val) > -1) {
                console.log(`weekly - updating interval from ${this.format} to 'MMMM DD, YYYY'`)
                this.format = 'MMMM DD, YYYY'
                this.viewMode = 'days'
            }
            else if (_.indexOf(['monthly', 'semi-monthly'], val) > -1) {
                console.log(`monthly/semi-monthly updating interval from ${this.format} to 'MMMM YYYY'`)
                this.format = 'MMMM YYYY'
                this.viewMode = 'months'
            }
        },
    },
}
</script>

<style scoped>

</style>